import { Skeleton } from '@mui/material';

import { VARIABLE_SOURCE_ROW_HEIGHT_PX } from './VariableSourceRow';

export const VariableSourceRowSkeleton = () => (
  <Skeleton
    variant="rectangular"
    height={VARIABLE_SOURCE_ROW_HEIGHT_PX}
    animation="wave"
    data-testid="analysis-variable-row-skeleton"
  />
);
